module.exports = __webpack_public_path__ + "img/组 4.d8ae716d.webp";